import React from 'react';

const PainDesire = () => {
  return (
    <section id="dor-desejo" className="py-20 bg-primary-black text-primary-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 relative">
            Você sente que...
            <span className="absolute bottom-0 left-0 w-24 h-1 bg-accent-red mt-2"></span>
          </h2>
          
          <div className="space-y-8 mb-12">
            <p className="text-xl leading-relaxed">
              Está preso(a) a padrões emocionais que se repetem e minam seus relacionamentos e escolhas?
            </p>
            
            <p className="text-xl leading-relaxed">
              Vive ou já viveu relações familiares e afetivas marcadas por conflitos, controle ou abuso emocional?
            </p>
            
            <p className="text-xl leading-relaxed">
              Não consegue se libertar de traumas psíquicos que continuam reverberando em sua vida presente?
            </p>
            
            <p className="text-xl leading-relaxed">
              Mesmo após se afastar de situações ou pessoas tóxicas, ainda carrega o peso emocional do passado?
            </p>
            
            <p className="text-xl leading-relaxed">
              Busca uma reconstrução profunda da sua identidade emocional, mas não sabe por onde começar?
            </p>
          </div>
          
          <div className="bg-dark-gray p-8 border-l-4 border-accent-red">
            <p className="text-xl mb-6">
              Se você respondeu "sim" a qualquer uma dessas perguntas, você está no lugar certo.
            </p>
            
            <p className="text-lg">
              O trabalho que desenvolvo não se limita a aliviar sintomas — é um convite para uma jornada de transformação, onde você poderá finalmente romper ciclos, reconstruir sua história e viver com liberdade emocional.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PainDesire;
